import Cuts from './Cuts';
export default Cuts;